
document.addEventListener("DOMContentLoaded", function() {
    // Select all instances of the section
    const isenseSections = document.querySelectorAll('.image-with-text-contanier-home');
    
    if (isenseSections.length > 0) {
        
        // 1. Set the initial hidden state and transition rules dynamically via JS
        isenseSections.forEach(section => {
            const imgWrapper = section.querySelector('.image-with-text__image-wrapper');
            const textWrapper = section.querySelector('.image-with-text__content-wrapper');
            
            if (imgWrapper) {
                // Initial state
                imgWrapper.style.opacity = '0';
                imgWrapper.style.transform = 'translateY(40px)';
                imgWrapper.style.visibility = 'hidden';
                // Transition properties
                imgWrapper.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out, visibility 0.8s';
            }
            
            if (textWrapper) {
                // Initial state
                textWrapper.style.opacity = '0';
                textWrapper.style.transform = 'translateY(40px)';
                textWrapper.style.visibility = 'hidden';
                // Transition properties (with a 0.2s delay for a staggered effect)
                textWrapper.style.transition = 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s, visibility 0.8s 0.2s';
            }
        });

        // 2. Set up the Intersection Observer
        const observerOptions = {
            root: null,
            threshold: 0.15, // Triggers when 15% of the section is visible
            rootMargin: "0px 0px -10% 0px" 
        };

        const sectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const section = entry.target;
                    const imgWrapper = section.querySelector('.image-with-text__image-wrapper');
                    const textWrapper = section.querySelector('.image-with-text__content-wrapper');

                    // 3. Trigger the animation using a tiny timeout 
                    // (This ensures the browser registers the initial hidden state before transitioning)
                    setTimeout(() => {
                        if (imgWrapper) {
                            imgWrapper.style.opacity = '1';
                            imgWrapper.style.transform = 'translateY(0)';
                            imgWrapper.style.visibility = 'visible';
                        }
                        
                        if (textWrapper) {
                            textWrapper.style.opacity = '1';
                            textWrapper.style.transform = 'translateY(0)';
                            textWrapper.style.visibility = 'visible';
                        }
                    }, 50);
                    
                    // Stop observing this specific section once it has animated
                    observer.unobserve(section);
                }
            });
        }, observerOptions);

        // 4. Observe all sections
        isenseSections.forEach(section => {
            sectionObserver.observe(section);
        });
    }
});

// Helper function: Ensures code runs even if DOMContentLoaded already fired (Common in dynamic themes)
function runOnReady(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}

// 1. Hero Section
(function() {
    const hero = document.querySelector('.mobile-showroom-contact-btn');
    if (hero) {
        hero.style.transition = "opacity 0.8s ease-out, transform 0.8s ease-out";
        setTimeout(() => {
            hero.style.setProperty('opacity', '1', 'important');
            hero.style.setProperty('transform', 'translateX(0)', 'important');
            hero.style.setProperty('visibility', 'visible', 'important');
        }, 50); 
    }
})();

runOnReady(function() {
    // 2. 3 Images Section 
    const images = document.querySelectorAll('.mobile-showroom-contact-img');
    if (images.length > 0) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        images.forEach((img, index) => {
                            setTimeout(() => {
                                img.classList.add('show-now');
                            }, index * 250); 
                        });
                    }, 100);
                    observer.unobserve(entry.target);
                }
            });
        }, { root: null, threshold: 0.15 }); // Reduced threshold for better mobile support
        
        imageObserver.observe(images[0].parentElement); 
    }

    // 3. Text Content Section
    const textElement = document.querySelector('.mobile-showroom-contact-text-content');
    if (textElement) {
        const textObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    textElement.classList.add('animate-in');
                    observer.unobserve(entry.target);
                }
            });
        }, { root: null, threshold: 0.2 }); // Changed from 0.8 to 0.2 to prevent mobile rendering bugs

        textObserver.observe(textElement.parentElement);
    }

    // 4. Image and Text Split Section (Refactored to IntersectionObserver)
    const textSide = document.querySelector('.mobile-showroom-contact-text-icon');
    const imageSide = document.querySelector('.mobile-showroom-contact-img-text');
    const splitTarget = textSide || imageSide;
    
    if (splitTarget) {
        const splitObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (textSide) textSide.classList.add('animate-now');
                    if (imageSide) imageSide.classList.add('animate-now');
                    observer.unobserve(entry.target);
                }
            });
        }, { root: null, rootMargin: "0px 0px -15% 0px" }); // Triggers when 15% above the bottom of viewport

        splitObserver.observe(splitTarget);
    }

    // 5. Video Section (Refactored to IntersectionObserver for performance)
    const allVideos = document.querySelectorAll('.mobile-showroom-contact-viedo');
    if (allVideos.length > 0) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    video.classList.add('video-reveal');
                    
                    const actualVideo = video.querySelector('video') || video;
                    if (actualVideo && typeof actualVideo.play === 'function') {
                        actualVideo.play().catch(e => console.log("Autoplay pending or blocked by browser"));
                    }
                    observer.unobserve(video);
                }
            });
        }, { root: null, rootMargin: "0px 0px -15% 0px" });

        allVideos.forEach(video => videoObserver.observe(video));
    }
});


document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.form-pop-up-btn');
  const section = document.querySelector('.pxFormGenerator');

  // 1. Function jo HTML inject karega aur events lagayega
  function injectCloseButton(formDiv) {
    if (!document.querySelector('.close-form-popup')) {
      formDiv.insertAdjacentHTML('beforeend', '<div class="close-form-popup">×</div>');
      
      const closeBtn = document.querySelector('.close-form-popup');
      closeBtn.addEventListener('click', function() {
        section.classList.remove('is-active');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      });
      console.log("Success: Close button injected!");
    }
  }

  // 2. Element ka intezar karne wala logic (Polling)
  const checkFormExist = setInterval(function() {
    const formDiv = document.querySelector('.form_generater_form_div');
    if (formDiv) {
      injectCloseButton(formDiv);
      // clearInterval(checkFormExist); // Agar aap chahte hain ke sirf ek baar chale
      // Lekin Hulk form refresh hota hai, isliye hum isay chalne denge ya observer lagayenge
    }
  }, 500); // Har half-second baad check karega

  // 3. Open Button Logic
  if (section && buttons.length > 0) {
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        section.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      });
    });

    // Outside click logic
    section.addEventListener('click', function(e) {
      if (e.target === section) {
        section.classList.remove('is-active');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
    
    document.addEventListener('click', function (e) {
        const anchor = e.target.closest('a');
        
        if (anchor) {
            const linkText = anchor.textContent.toLowerCase();
            
            // FIX: Now it requires the class AND the word "chat" to be present, 
            // completely ignoring the "Call an iSense Expert" button.
            if ((anchor.classList.contains('is-expert-action-btn') && linkText.includes('chat')) || 
                linkText.includes('chat us') || 
                linkText.includes('chat now')) {
                
                e.preventDefault(); 
                e.stopPropagation(); 
                
                if (typeof GorgiasChat !== 'undefined' && typeof GorgiasChat.open === 'function') {
                    GorgiasChat.open(); 
                } else {
                    const gorgiasButton = document.getElementById('gorgias-chat-messenger-button');
                    if (gorgiasButton) gorgiasButton.click();
                }
                return;
            }
        }

        const gorgiasContainer = document.getElementById('gorgias-chat-container');
        if (gorgiasContainer && !gorgiasContainer.contains(e.target)) {
            if (typeof GorgiasChat !== 'undefined' && typeof GorgiasChat.close === 'function') {
                GorgiasChat.close();
            }
        }
    }, true); 
});



document.addEventListener("DOMContentLoaded", function () {
  
  function applyWordBreaks(selector, breakIndices) {
    document.querySelectorAll(selector).forEach(heading => {
      const words = heading.innerText.trim().split(/\s+/);
      let newHTML = '';

      for (let i = 0; i < words.length; i++) {
        newHTML += words[i];
        
        if (breakIndices.includes(i) && i !== words.length - 1) {
          // Span ke baad space add kar di hai
          newHTML += '<span class="mobile-break"></span> ';
        } else {
          newHTML += ' ';
        }
      }
      heading.innerHTML = newHTML;
    });
  }

  // 1. Target: Specific parent class (Har 2 words ke baad break)
  document.querySelectorAll('.deigned-to-solve .tq-main-heading').forEach(heading => {
    const words = heading.innerText.trim().split(/\s+/);
    let newHTML = '';
    for (let i = 0; i < words.length; i++) {
      newHTML += words[i];
      if ((i + 1) % 2 === 0 && i !== words.length - 1) {
        newHTML += '<span class="mobile-break"></span> ';
      } else {
        newHTML += ' ';
      }
    }
    heading.innerHTML = newHTML;
  });

  // 2. Target: Pehli line 2 words, Doosri line 3 words
  applyWordBreaks('.image-with-text-contanier-home .image-with-text__content .heading.h3', [1, 4]);

  // 3. Target: Pehli line 4 words, Doosri line 3 words
  applyWordBreaks('.image-with-text-contanier-home-wrapper .heading.h3', [3, 6]);

});


window.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const id = 'input[value="King FlexHead™"]';
    const input = document.querySelector(id);
    if (!input) return;

    // Patch focus so the browser doesn't scroll to it
    const originalFocus = input.focus;
    input.focus = function (opts) {
      return originalFocus.call(this, { ...opts, preventScroll: true });
    };

    // Real click → theme's variant handler runs → image, price, URL all update
    input.click();

    input.focus = originalFocus;
  }, 1200);
  
});
window.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(max-width: 768px)').matches) {
        const container = document.querySelector('.vsc-main-container.viedo-contanier-home-clean-clean');
        if (container) {
            const h1 = container.querySelector('h1');
            if (h1) {
                h1.innerHTML = h1.innerHTML.replace('. ', '.<br>');
            }
        }
    }
});


/* =========================================================
   iSense - Section Scroll Animations
   Only JS file required
   ========================================================= */
(function () {
  'use strict';
  /* =========================================================
     1. PAGES WHERE ANIMATION SHOULD WORK
     ========================================================= */

  const ANIMATION_PAGES = [
    '/',
    '/products/isense-hybrid-premier'
  ];
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  if (!ANIMATION_PAGES.includes(currentPath)) {
    return;
  }
  /* =========================================================
     2. ADD YOUR SECTION SELECTORS HERE
     
     IMPORTANT:
     Put the EXISTING class/id of the section here.
     
     Example:
     '.shopify-section--123456'
     '#shopify-section-template--123456__abc'
     '.my-existing-section'
     
     You do NOT need to add these classes to the section.
     Just put the class/id that already exists.
     ========================================================= */
  const ANIMATION_SECTIONS = {
    TOP: [
      '.smart-mattress .multi-column__inner.multi-column__inner--center',
      '.deigned-to-solve .tq-bleed-container',
      '.rich-main-wrapper .container',
      '.columns-heading .comp-grid',
    ],
    BOTTOM: [
      '.viedo-contanier-home-clean-clean',
      '.better-sleep',
      '.comfort-control-technology .vos-box',
      '.built-to-solve',
      '.real-sleepers-real-results .zz-grid',
    ],
    LEFT: [
      '.main-wrapper-blocks .banner-container',
      '.custom-promo-wrapper .banner-container',
      '.image-with-text-contanier-home .split-wrapper-contanier',
      '.expert-store',
      '.inside-the-world',
      '.built-in-missouri .consultation-wrapper'
    ],
    RIGHT: [
      '.comfort-image-wrapper',
      '.multi-column-container .multi-column__inner.multi-column__inner--center ',
      '.the-expert-say .expert-outer-wrapper',
      '.founder-content-wrapper .founder-container'
    ]
  };
  /* =========================================================
     3. ANIMATION SETTINGS
     ========================================================= */
const SETTINGS = {
  duration: 1000,                      // Speed badha kar smooth feel di hai (800ms -> 1000ms)
  distance: 50,                        // Distance kam karne se movement zyada smooth aur clean lagti hai (80ms -> 50ms)
  delay: 0,            
  easing: 'cubic-bezier(0.16, 1, 0.3, 1)', // Zyada natural aur ultra-smooth easing
  threshold: 0.2,                      // 0.4 ka matlab hai jab 40% section screen par aayega tab animation start hogi
  once: true
};
  /* =========================================================
     4. ADD CSS AUTOMATICALLY
     No CSS file required
     ========================================================= */
  const style = document.createElement('style');
  style.textContent = `
    .isense-scroll-animation {
      opacity: 0;
      transition:
        transform ${SETTINGS.duration}ms ${SETTINGS.easing},
        opacity ${SETTINGS.duration}ms ease;
      will-change: transform, opacity;
    }
    .isense-scroll-animation.isense-animate {
      opacity: 1;
      transform: translate3d(0, 0, 0) !important;
    }
    .isense-from-top {
      transform: translate3d(0, -${SETTINGS.distance}px, 0);
    }
    .isense-from-bottom {
      transform: translate3d(0, ${SETTINGS.distance}px, 0);
    }
    .isense-from-left {
      transform: translate3d(-${SETTINGS.distance}px, 0, 0);
    }
    .isense-from-right {
      transform: translate3d(${SETTINGS.distance}px, 0, 0);
    }
    @media (prefers-reduced-motion: reduce) {
      .isense-scroll-animation {
        opacity: 1 !important;
        transform: none !important;
        transition: none !important;
      }
    }
  `;
  document.head.appendChild(style);
  /* =========================================================
     5. SELECTOR → ELEMENTS
     ========================================================= */
  function getElements(selectors) {
    const elements = [];
    selectors.forEach(function (selector) {
      try {
        const found = document.querySelectorAll(selector);
        // TASALLI KE LIYE YAHAN CONSOLE LAGA LEIN
        if (found.length > 0) {
           console.log(`[Animation Found] "${selector}" kitni dafa mila? =`, found.length);
        }
        
        found.forEach(function (element) {
          if (!elements.includes(element)) {
            elements.push(element);
          }
        });
      } catch (error) {
        console.warn('[iSense Animation] Invalid selector:', selector);
      }
    });
    return elements;
  }
  /* =========================================================
     6. PREPARE ALL ANIMATED SECTIONS
     ========================================================= */
  const animationGroups = [
    {
      direction: 'top',
      selectors: ANIMATION_SECTIONS.TOP
    },
    {
      direction: 'bottom',
      selectors: ANIMATION_SECTIONS.BOTTOM
    },
    {
      direction: 'left',
      selectors: ANIMATION_SECTIONS.LEFT
    },
    {
      direction: 'right',
      selectors: ANIMATION_SECTIONS.RIGHT
    }
  ];
  const animatedElements = [];
  animationGroups.forEach(function (group) {
    const elements = getElements(group.selectors);
    elements.forEach(function (element) {
      /* Don't animate the same section twice */
      if (animatedElements.includes(element)) {
        return;
      }
      animatedElements.push(element);
      element.classList.add('isense-scroll-animation');
      element.classList.add(
        'isense-from-' + group.direction
      );
    });
  });
  /* =========================================================
     7. INTERSECTION OBSERVER
     Animates section when it enters viewport
     ========================================================= */
  if (!('IntersectionObserver' in window)) {
    animatedElements.forEach(function (element) {
      element.classList.add('isense-animate');
    });
    return;
  }
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        const element = entry.target;
        const delay =
          element.dataset.isenseDelay ||
          SETTINGS.delay;
        setTimeout(function () {
          element.classList.add('isense-animate');
        }, Number(delay));
        if (SETTINGS.once) {
          observer.unobserve(element);
        }
      });
    },
    {
      threshold: SETTINGS.threshold,
      rootMargin: '0px 0px -50px 0px'
    }
  );
  /* =========================================================
     8. START OBSERVING
     ========================================================= */

  animatedElements.forEach(function (element) {
    observer.observe(element);
  });
})();




// Text ko number ma badlna ka liya code start

document.addEventListener('DOMContentLoaded', function () {

  // Expert Store
  const expertStore = document.querySelector('.expert-store');

  if (expertStore && window.innerWidth >= 750) {
    const clickToCall = expertStore.querySelector('a[href^="tel:"]');

    if (clickToCall) {
      clickToCall.textContent = '(866) 910-8605';
      clickToCall.removeAttribute('href');
      clickToCall.classList.add('desktop-phone-number');
      clickToCall.style.pointerEvents = 'none';
      clickToCall.style.cursor = 'default';
    }
  }

  // Expert Virtual Store
  const expertVirtualStore = document.querySelector('.expert-virtual-store');

  if (expertVirtualStore && window.innerWidth >= 750) {
    const elements = expertVirtualStore.querySelectorAll('*');

    elements.forEach(function (element) {

      if (element.textContent.trim() === 'Click to Call') {
        element.textContent = '(866) 910-8605';
        element.classList.add('desktop-phone-number');
        element.style.fontWeight = '700';

        if (element.tagName === 'A') {
          element.removeAttribute('href');
          element.style.pointerEvents = 'none';
          element.style.cursor = 'default';
        }
      }

    });
  }

});

// Text ko number ma badlna ka liya code end


document.addEventListener("DOMContentLoaded", function () {
  // Target container with 'adjustable-comfort' class
  const targetContainer = document.querySelector(".adjustable-comfort");

  if (targetContainer) {
    // Find the heading inside this specific container
    const heading = targetContainer.querySelector(".comfort-title");

    if (heading) {
      // Split heading text into words
      const words = heading.textContent.trim().split(/\s+/);

      // Check if heading has at least 6 words
      if (words.length >= 6) {
        const line1 = words.slice(0, 3).join(" ");
        const line2 = words.slice(3, 6).join(" ");
        const remainingWords = words.slice(6).join(" ");

        // Reconstruct heading with line breaks
        heading.innerHTML = `${line1}<br>${line2}${
          remainingWords ? "<br>" + remainingWords : ""
        }`;
      }
    }
  }
});




document.addEventListener("click", function(event) {
  // Check karein ke click hone wala element woh button hai ya nahi
  // Yahan apnay doosray button ki class ya ID laga dein (misal ke tor par .second-page-btn)
  if (event.target.closest(".learn_more")) {
    event.preventDefault(); // Page ko reload ya redirect honay se rokein
    
    // Pehle button wala popup ya uska trigger dhoondein
    const originalButton = document.querySelector(".syf-cta");
    
    if (originalButton) {
      // Direct original button par click trigger kar dein taake wahi popup khul jaye
      originalButton.click();
    }
  }
});



  document.addEventListener('click', function(e) {
    // Review link click capture
    const reviewLink = e.target.closest('a.product-meta__reviews-badge, a[href*="reviews-pocket"], a[href*="-tabs"]');
    
    if (reviewLink) {
      e.preventDefault(); // Default hash jump change handle karega
      
      // Target section detect
      const targetSection = document.querySelector('#shopify-section-template--27912677818682__1782976875588affdb') 
                         || document.querySelector('[id*="junip-product-review"]')
                         || document.querySelector('.junip-product-review');

      if (targetSection) {
        // Sticky Header Adjustment (Agat header fixed ho)
        const headerOffset = 100;
        const elementPosition = targetSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }, true); // UseCapture mode flag fast execution ke liye



  // function formatSpringfieldHeading() {
  //   // Target heading element by class or tag inside alia container
  //   const headings = document.querySelectorAll('.alia-style-heading-1, [class*="alia-style-heading-"]');
    
  //   headings.forEach(heading => {
  //     if (heading.innerText.includes("YOU'RE ON THE SPRINGFIELD VIP LIST.")) {
  //       heading.innerHTML = "YOU'RE ON THE<br>SPRINGFIELD VIP LIST.";
  //     }
  //   });
  // }

  // // Run on page load
  // document.addEventListener("DOMContentLoaded", formatSpringfieldHeading);

  // // Observer to handle dynamic loading of Alia App widget
  // const observer = new MutationObserver(function(mutations) {
  //   formatSpringfieldHeading();
  // });

  // observer.observe(document.body, { childList: true, subtree: true });
  